import { render, staticRenderFns } from "./TongxinNavigation.vue?vue&type=template&id=0d7605c4&scoped=true&"
import script from "./TongxinNavigation.vue?vue&type=script&lang=js&"
export * from "./TongxinNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TongxinNavigation.vue?vue&type=style&index=0&id=0d7605c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7605c4",
  null
  
)

export default component.exports